import { createSlice } from "@reduxjs/toolkit";

// دالة لتحويل اللغة من string إلى object
const langObjectFromString = (lang) => {
  const value =
    String(lang || "")
      .toLowerCase()
      .startsWith("ar") ? "ar" : "en";
  return value === "ar"
    ? { label: "عربي", value: "ar" }
    : { label: "English", value: "en" };
};

const getLangValueFromGeneralSettings = (generalSettings) => {
  if (!Array.isArray(generalSettings)) return null;
  const matched = generalSettings.find(
    (item) =>
      item?.name === "DEFAULT_LANG" || item?.settingName === "DEFAULT_LANG"
  );
  if (matched?.value) return matched.value;
  return generalSettings[5]?.value || null;
};

// جلب اللغة من tenant في localStorage
const getPreferredLang = () => {
  try {
    const stored = localStorage.getItem("preferredLang");
    if (stored) return stored;
    const fromI18n = localStorage.getItem("i18nextLng");
    if (fromI18n) return fromI18n;
    const fromAppLang = localStorage.getItem("appLang");
    if (fromAppLang) return fromAppLang;
    return null;
  } catch (error) {
    return null;
  }
};

const getLangFromTenant = () => {
  try {
    const preferred = getPreferredLang();
    if (preferred) {
      return langObjectFromString(preferred);
    }
    const tenant = JSON.parse(localStorage.getItem("tenant"));
    const generalSettings = tenant?.companies?.[0]?.settings?.generalSettings;
    const lang = getLangValueFromGeneralSettings(generalSettings);
    return langObjectFromString(lang);
  } catch (error) {
    return { label: "English", value: "en" };
  }
};

const langSlice = createSlice({
  name: "lang",
  initialState: getLangFromTenant(),
  reducers: {
    setLang: (state, action) => {
      const payloadValue = action?.payload?.value;
      const payloadLabel = action?.payload?.label;
      if (payloadValue) {
        const normalized = langObjectFromString(payloadValue);
        state.label = payloadLabel || normalized.label;
        state.value = normalized.value;
        try {
          localStorage.setItem("preferredLang", normalized.value);
        } catch (error) {
        }
        return;
      }
      const preferred = getPreferredLang();
      if (preferred) {
        const normalized = langObjectFromString(preferred);
        state.label = normalized.label;
        state.value = normalized.value;
        return;
      }
      const tenant = JSON.parse(localStorage.getItem("tenant"));
      const generalSettings = tenant?.companies?.[0]?.settings?.generalSettings;
      const lang = getLangValueFromGeneralSettings(generalSettings);
      const fromTenant = langObjectFromString(lang);
      state.label = fromTenant.label;
      state.value = fromTenant.value;
    },
  },
});

export const { setLang } = langSlice.actions;

// مراقبة التغيير من tenant تلقائيًا
export const startLangWatcher = () => (dispatch, getState) => {
  let previousLang = getState().lang.value;

  setInterval(() => {
    const tenantLang = getLangFromTenant().value;
    if (tenantLang !== previousLang) {
      previousLang = tenantLang;
      dispatch(setLang()); // نحدث الحالة
    }
  }, 500);
};

export default langSlice.reducer;
